import type { ColumnKey, IConfigurableColumn } from '@shared/table/types';

import i18n from '@features/i18n';

export interface IColumnDefinition {
  value: ColumnKey;
  labelKey: string;
  isVisible?: boolean;
  sortingId: null | string;
}

export const defineColumn = (
  definition: IColumnDefinition
): IColumnDefinition => definition;

export const createConfigurableColumns = (
  definitions: IColumnDefinition[]
): IConfigurableColumn[] =>
  definitions.map((definition, index) => ({
    order: index + 1,
    value: definition.value,
    sortingId: definition.sortingId,
    label: i18n.t(definition.labelKey),
    isVisible: definition.isVisible ?? true,
  }));
